import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'
import { Subtitle1 } from '@src/elements/typography/typography'
import { Checkbox } from '@src/elements/input/checkbox'
import { Button } from '@src/elements/button/button'
import { Message } from '@src/data/message'
import ApiClient from '@src/lib/api_client'
import Member from '@src/data/member'
import { Modal } from '@src/elements/modal/modal'
import { FlagsCell } from '@src/routes/members/components/list/flags-cell'
import { NameCell } from '@src/routes/messaging/name-cell'
import { API } from '@src/lib/api_path'
import { snakecaseKeys } from '@src/util/functions'
import { Icon } from '@src/elements/icon/icon'

@Component
export class ConfirmRecipients extends Vue {

  @Prop({ required: false, default: [] })
  private members: Member[]

  @Prop({ required: false, default: [] })
  private message: Message

  @Prop({ required: true })
  private closeCallback: (send?: boolean) => void

  private recipients: { member: Member, confirmed: boolean, hasData: boolean }[] = []

  private apiClient: ApiClient = new ApiClient()

  private showError: boolean = false

  created () {
    this.recipients = Object.assign([], this.members.map(member => {
      let hasData = true
      if (this.message.emailNotification) hasData = !!member.email
      if (this.message.pushNotification) hasData = hasData && member.mobile
      return { member: member, confirmed: true, hasData: hasData }
    }))
    this.showError = this.recipients.some((recipient) => !recipient.hasData)
  }

  render (h: CreateElement) {
    const members = this.recipients.map((recipient, index) => {
      return <div class='row'>
        <Checkbox value={recipient.confirmed} change={() => this.check(index)} />
        <NameCell item={recipient.member} click={() => this.check(index)} showAlert={!recipient.hasData}/>
        <FlagsCell item={recipient.member} />
      </div>
    })
    const disableSend = this.recipients.filter(recipient => recipient.confirmed).length === 0

    return <Modal show={true} title={this.$t('PAGE.MESSAGING.SEND_MESSAGE')} closeCallback={this.send} cssClass='confirm-recipients-modal'>
      <Subtitle1>{this.$t('PAGE.MESSAGING.SEND_MESSAGE_CONFIRM', { userCount: members.length })}</Subtitle1>
      <div class='confirm-list'>
        {members}
      </div>
      <div slot='footer'>
        {this.showError && <div class='error-message'><Icon name='util/alert' /> {this.$t('PAGE.MESSAGING.MISSING_DATA_ERROR')}</div>}
        <div class='btn-row'>
          <Button type='outline' label={this.$t('CANCEL')} click={this.send} ref='cancel' />
          <Button type='elevated' label={this.$t('PAGE.MESSAGING.SEND')} click={() => this.send(true)} ref='confirm' disabled={disableSend} />
        </div>
      </div>
    </Modal>
  }

  async send (confirm?: boolean) {
    let message = new Message(this.message)
    message.memberIds = Array.from(new Set(
      this.recipients
        .filter(recipient => recipient.confirmed)
        .map(recipient => recipient.member.id)
    ))

    if (confirm === true) {
      return this.apiClient.post(API.TRAINERS_API.MESSAGES, { member_notification: snakecaseKeys(message) })
        .then(() => {
          this.$store.dispatch('showToast', { message: this.$t('PAGE.MESSAGING.MESSAGE_SENT'), fadeOut: true })
          this.closeCallback(true)
        })
    } else {
      this.closeCallback()
    }
  }

  check (index: number) {
    this.recipients[index].confirmed = !this.recipients[index].confirmed
  }
}
